import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContBtn,
  ContFacilitarAgilizarProcesos,
  ContInfoFacilitarAgilizarProcesos,
  ContVideo,
  TextFacilitarAgilizarProcesos,
  TitleFacilitarAgilizarProcesos,
} from './FacilitarAgilizarProcesos.styles';
import ButtonSpecial from '../ButtonSpecial';
import VideoAgilProcess from '../../assets/videos/procesos.mp4';

export const FacilitarAgilizarProcesos = () => {
  const { t } = useTranslation();
  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;

    // Asegúrate de que el video esté listo para ser reproducido
    const handleCanPlay = () => {
      videoElement.play().catch((error) => {
        console.error("El video no pudo reproducirse automáticamente:", error);
      });
    };

    if (videoElement) {
      videoElement.addEventListener('canplay', handleCanPlay);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener('canplay', handleCanPlay);
      }
    };
  }, []);

  return (
    <ContFacilitarAgilizarProcesos id={'ContFacilitarAgilizarProcesos'}>
      <div className={'container-fit'}>
        <ContInfoFacilitarAgilizarProcesos>
          <TitleFacilitarAgilizarProcesos>
            {t('Facilitamos y agilizamos tus procesos')}
          </TitleFacilitarAgilizarProcesos>
          <TextFacilitarAgilizarProcesos>
            {t(
              'Creamos una plataforma 100% intuitiva donde tú eliges a los proveedores que mejor se adapten a tu estrategia, y te ayuden a agilizar operaciones internas y externas.'
            )}
          </TextFacilitarAgilizarProcesos>
          <ContBtn id={'ContBtn'}>
            <ButtonSpecial
              text={'Ir al marketplace'}
              type={'/'}
              location={'/marketplace'}
              theme={'primary'}
            />
          </ContBtn>
        </ContInfoFacilitarAgilizarProcesos>
        <ContVideo>
          <video
            id={'video'}
            ref={videoRef}
            autoPlay={false}
            controls={false}
            loop={true}
          >
            <source src={VideoAgilProcess} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </ContVideo>
      </div>
    </ContFacilitarAgilizarProcesos>
  );
};
